import React, { useEffect, useState } from "react";
import { api, formatApiError } from "../lib/api";
import { X, Plus, Trash2, Loader2, Euro } from "lucide-react";
import { toast } from "sonner";

const BLANK_TIP = { id: "", nome: "", importo_base: 0, importo_per_kw: 0, kit: [] };

export default function CommessaEconomicoModal({ commessa, onClose }) {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [prodotti, setProdotti] = useState([]);
  const [eco, setEco] = useState({ sopralluogo_importo: 0, extra_kw_importo: 0, wallbox_importo: 0, pratiche_gse_importo: 0, pdc_importo: 0, commutatore_importo: 0, climatizzatore_importo: 0, bonus_responsabile: 0, bonus_installatore: 0, bonus_supervisore: 0, tipologie: [], voci_extra: [] });
  const [selTip, setSelTip] = useState(0);

  useEffect(() => {
    (async () => {
      try {
        const [eRes, pRes] = await Promise.all([
          api.get(`/commesse/${commessa.id}/economics`),
          api.get(`/prodotti?commessa_id=${commessa.id}`),
        ]);
        setEco(eRes.data);
        setProdotti(pRes.data);
      } catch (err) { toast.error(formatApiError(err)); }
      finally { setLoading(false); }
    })();
  }, [commessa.id]);

  const num = (v) => (v === "" ? 0 : parseFloat(v) || 0);

  const setTip = (i, patch) => {
    const tipologie = eco.tipologie.map((t, idx) => (idx === i ? { ...t, ...patch } : t));
    setEco({ ...eco, tipologie });
  };
  const setKitItem = (ti, ki, patch) => {
    const kit = eco.tipologie[ti].kit.map((k, idx) => (idx === ki ? { ...k, ...patch } : k));
    setTip(ti, { kit });
  };

  const save = async () => {
    for (const t of eco.tipologie) {
      if (!t.nome.trim()) { toast.error("Ogni tipologia deve avere un nome"); return; }
      for (const k of t.kit) {
        if (!k.prodotto_id) { toast.error(`Seleziona il prodotto in tutte le righe kit di "${t.nome}"`); return; }
      }
    }
    for (const v of (eco.voci_extra || [])) {
      if (!(v.nome || "").trim()) { toast.error("Ogni voce extra deve avere un nome"); return; }
    }
    setSaving(true);
    try {
      const { data } = await api.put(`/commesse/${commessa.id}/economics`, eco);
      setEco(data);
      toast.success("Economico commessa salvato");
      onClose();
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setSaving(false); }
  };

  const inputCls = "mt-1 w-full px-3 py-2 text-sm rounded-md border outline-none";
  const inputStyle = { borderColor: "var(--border)", background: "#fff" };
  const lblCls = "block text-[11px] font-semibold uppercase tracking-wider whitespace-nowrap overflow-hidden text-ellipsis";
  const lblStyle = { color: "var(--text-muted)" };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40" onClick={onClose}>
      <div className="card-shell w-full max-w-3xl max-h-[90vh] flex flex-col" onClick={(e) => e.stopPropagation()} data-testid="commessa-economico-modal">
        <div className="p-5 border-b flex justify-between items-center" style={{ borderColor: "var(--border)" }}>
          <h2 className="text-xl font-bold flex items-center gap-2" style={{ fontFamily: "Manrope" }}>
            <Euro className="w-5 h-5" style={{ color: "var(--primary)" }} /> Economico — {commessa.name}
          </h2>
          <button onClick={onClose} className="p-1.5 rounded hover:bg-black/5" data-testid="close-economico-modal"><X className="w-4 h-4" /></button>
        </div>

        {loading ? (
          <div className="p-8 flex items-center gap-2 text-sm"><Loader2 className="w-4 h-4 animate-spin" /> Caricamento…</div>
        ) : (
          <div className="p-6 space-y-6 overflow-y-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div>
                <label className={lblCls} style={lblStyle} title="Importo sopralluogo €">Sopralluogo €</label>
                <input type="number" step="0.01" data-testid="eco-sopralluogo-importo" value={eco.sopralluogo_importo}
                  onChange={(e) => setEco({ ...eco, sopralluogo_importo: num(e.target.value) })} className={inputCls} style={inputStyle} />
              </div>
              <div>
                <label className={lblCls} style={lblStyle} title="€ per ogni kW attivato in più rispetto al pianificato">€ x kW extra</label>
                <input type="number" step="0.01" data-testid="eco-extra-kw-importo" value={eco.extra_kw_importo ?? 0}
                  onChange={(e) => setEco({ ...eco, extra_kw_importo: num(e.target.value) })} className={inputCls} style={inputStyle} />
              </div>
              <div>
                <label className={lblCls} style={lblStyle} title="Bonus responsabile squadra €">Bonus responsabile €</label>
                <input type="number" step="0.01" data-testid="eco-bonus-responsabile" value={eco.bonus_responsabile}
                  onChange={(e) => setEco({ ...eco, bonus_responsabile: num(e.target.value) })} className={inputCls} style={inputStyle} />
              </div>
              <div>
                <label className={lblCls} style={lblStyle} title="Bonus installatore €">Bonus installatore €</label>
                <input type="number" step="0.01" data-testid="eco-bonus-installatore" value={eco.bonus_installatore}
                  onChange={(e) => setEco({ ...eco, bonus_installatore: num(e.target.value) })} className={inputCls} style={inputStyle} />
              </div>
              <div>
                <label className={lblCls} style={lblStyle} title="Bonus supervisore squadre €">Bonus supervisore €</label>
                <input type="number" step="0.01" data-testid="eco-bonus-supervisore" value={eco.bonus_supervisore ?? 0}
                  onChange={(e) => setEco({ ...eco, bonus_supervisore: num(e.target.value) })} className={inputCls} style={inputStyle} />
              </div>
              <div>
                <label className={lblCls} style={lblStyle} title="Importo Wallbox €">Wallbox €</label>
                <input type="number" step="0.01" data-testid="eco-wallbox-importo" value={eco.wallbox_importo ?? 0}
                  onChange={(e) => setEco({ ...eco, wallbox_importo: num(e.target.value) })} className={inputCls} style={inputStyle} />
              </div>
              <div>
                <label className={lblCls} style={lblStyle} title="Importo Pratiche GSE €">Pratiche GSE €</label>
                <input type="number" step="0.01" data-testid="eco-gse-importo" value={eco.pratiche_gse_importo ?? 0}
                  onChange={(e) => setEco({ ...eco, pratiche_gse_importo: num(e.target.value) })} className={inputCls} style={inputStyle} />
              </div>
              <div>
                <label className={lblCls} style={lblStyle} title="Importo PDC €">PDC €</label>
                <input type="number" step="0.01" data-testid="eco-pdc-importo" value={eco.pdc_importo ?? 0}
                  onChange={(e) => setEco({ ...eco, pdc_importo: num(e.target.value) })} className={inputCls} style={inputStyle} />
              </div>
              <div>
                <label className={lblCls} style={lblStyle} title="Importo Commutatore €">Commutatore €</label>
                <input type="number" step="0.01" data-testid="eco-commutatore-importo" value={eco.commutatore_importo ?? 0}
                  onChange={(e) => setEco({ ...eco, commutatore_importo: num(e.target.value) })} className={inputCls} style={inputStyle} />
              </div>
              <div>
                <label className={lblCls} style={lblStyle} title="Importo Climatizzatore €">Climatizzatore €</label>
                <input type="number" step="0.01" data-testid="eco-climatizzatore-importo" value={eco.climatizzatore_importo ?? 0}
                  onChange={(e) => setEco({ ...eco, climatizzatore_importo: num(e.target.value) })} className={inputCls} style={inputStyle} />
              </div>
            </div>
            <p className="text-xs -mt-3" style={{ color: "var(--text-muted)" }}>
              Se un installatore è in affiancamento (nuovo dipendente) il suo bonus viene girato al responsabile squadra.
              "€ x kW extra" valorizza ogni kW installato in più rispetto al pianificato.
              Wallbox, Pratiche GSE, PDC, Commutatore e Climatizzatore vengono aggiunti al fatturato del cliente quando il flag è attivo nella sua scheda economico.
            </p>

            {/* --------- Voci extra personalizzate --------- */}
            <div>
              <div className="flex items-center justify-between mb-2">
                <div className="text-sm font-bold" style={{ fontFamily: "Manrope" }}>Voci extra personalizzate</div>
                <button
                  onClick={() => setEco({ ...eco, voci_extra: [...(eco.voci_extra || []), { id: "", nome: "", importo: 0 }] })}
                  className="btn-secondary text-xs" data-testid="add-voce-extra-btn">
                  <Plus className="w-3.5 h-3.5" /> Aggiungi voce
                </button>
              </div>
              {(eco.voci_extra || []).length === 0 ? (
                <div className="text-sm p-4 rounded-md text-center" style={{ background: "var(--surface-muted)", color: "var(--text-muted)" }} data-testid="voci-extra-empty">
                  Nessuna voce extra. Aggiungi voci personalizzate (es. "Colonnina EV", "Ottimizzatori") che potrai attivare per singolo cliente dalla sua scheda economico.
                </div>
              ) : (
                <div className="space-y-2">
                  {(eco.voci_extra || []).map((v, vi) => (
                    <div key={vi} className="grid grid-cols-12 gap-2 items-center p-2 rounded-md border" style={{ borderColor: "var(--border)", background: "var(--surface)" }} data-testid={`voce-extra-row-${vi}`}>
                      <input
                        type="text" placeholder="Nome voce (es. Colonnina EV)"
                        value={v.nome || ""}
                        onChange={(e) => setEco({ ...eco, voci_extra: (eco.voci_extra || []).map((x, i) => i === vi ? { ...x, nome: e.target.value } : x) })}
                        className="col-span-7 px-3 py-2 text-sm rounded-md border outline-none"
                        style={inputStyle}
                        data-testid={`voce-extra-nome-${vi}`}
                      />
                      <div className="col-span-4 flex items-center gap-1">
                        <input
                          type="number" step="0.01" placeholder="€"
                          value={v.importo ?? 0}
                          onChange={(e) => setEco({ ...eco, voci_extra: (eco.voci_extra || []).map((x, i) => i === vi ? { ...x, importo: num(e.target.value) } : x) })}
                          className="flex-1 px-3 py-2 text-sm rounded-md border outline-none"
                          style={inputStyle}
                          data-testid={`voce-extra-importo-${vi}`}
                        />
                        <Euro className="w-3.5 h-3.5" style={{ color: "var(--text-muted)" }} />
                      </div>
                      <button
                        onClick={() => setEco({ ...eco, voci_extra: (eco.voci_extra || []).filter((_, i) => i !== vi) })}
                        className="col-span-1 flex items-center justify-center p-2 rounded-md hover:bg-red-50"
                        style={{ color: "#dc2626" }}
                        title="Rimuovi voce"
                        data-testid={`voce-extra-remove-${vi}`}>
                        <Trash2 className="w-4 h-4" />
                      </button>
                    </div>
                  ))}
                </div>
              )}
              <p className="text-xs mt-2" style={{ color: "var(--text-muted)" }}>
                Queste voci vengono attivate/disattivate cliente per cliente dalla sua scheda economico.
              </p>
            </div>

            <div>
              <div className="flex items-center justify-between mb-2">
                <div className="text-sm font-bold" style={{ fontFamily: "Manrope" }}>Tipologie impianto</div>
                <button onClick={() => { setEco({ ...eco, tipologie: [...eco.tipologie, { ...BLANK_TIP }] }); setSelTip(eco.tipologie.length); }}
                  className="btn-secondary text-xs" data-testid="add-tipologia-btn">
                  <Plus className="w-3.5 h-3.5" /> Aggiungi tipologia
                </button>
              </div>
              {eco.tipologie.length === 0 ? (
                <div className="text-sm p-4 rounded-md text-center" style={{ background: "var(--surface-muted)", color: "var(--text-muted)" }}>
                  Nessuna tipologia. Aggiungi la prima (es. "Impianto 6kW con batteria").
                </div>
              ) : (
                <div className="mb-3">
                  <label className={lblCls} style={lblStyle}>Seleziona tipologia da visualizzare / modificare</label>
                  <select value={selTip} onChange={(e) => setSelTip(parseInt(e.target.value, 10))}
                    className="mt-1 w-full md:w-1/2 px-3 py-2 text-sm rounded-md border outline-none" style={inputStyle}
                    data-testid="tipologia-selector">
                    {eco.tipologie.map((t, ti) => (
                      <option key={ti} value={ti}>{t.nome || `Nuova tipologia ${ti + 1}`}</option>
                    ))}
                  </select>
                </div>
              )}
              <div className="space-y-4">
                {eco.tipologie.map((t, ti) => ti === selTip && (
                  <div key={ti} className="rounded-lg border p-4" style={{ borderColor: "var(--border)" }} data-testid={`tipologia-row-${ti}`}>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                      <div className="col-span-2">
                        <label className={lblCls} style={lblStyle}>Nome tipologia *</label>
                        <input data-testid={`tipologia-nome-${ti}`} value={t.nome} onChange={(e) => setTip(ti, { nome: e.target.value })}
                          placeholder="Es. Impianto 6kW con batteria" className={inputCls} style={inputStyle} />
                      </div>
                      <div>
                        <label className={lblCls} style={lblStyle}>Importo base €</label>
                        <input type="number" step="0.01" data-testid={`tipologia-importo-${ti}`} value={t.importo_base}
                          onChange={(e) => setTip(ti, { importo_base: num(e.target.value) })} className={inputCls} style={inputStyle} />
                      </div>
                      <div>
                        <label className={lblCls} style={lblStyle} title="Calcolo variabile: € x kW">€ x kW (variabile)</label>
                        <input type="number" step="0.01" data-testid={`tipologia-perkw-${ti}`} value={t.importo_per_kw}
                          onChange={(e) => setTip(ti, { importo_per_kw: num(e.target.value) })} className={inputCls} style={inputStyle} />
                      </div>
                    </div>

                    <div className="mt-4 rounded-md p-3" style={{ background: "var(--surface-muted)" }}>
                      <div className="flex items-center justify-between mb-2">
                        <span className={lblCls} style={lblStyle}>Kit prodotti previsti (per calcolo extra)</span>
                        <button onClick={() => setTip(ti, { kit: [...t.kit, { prodotto_id: "", quantita: 1, prezzo_extra: 0 }] })}
                          className="text-xs font-semibold px-2 py-1 rounded hover:bg-black/5" style={{ color: "var(--primary)" }}
                          data-testid={`add-kit-item-${ti}`}>
                          + Prodotto
                        </button>
                      </div>
                      {t.kit.length > 0 && (
                        <div className="grid grid-cols-[1fr_90px_110px_32px] gap-2 mb-1 px-0.5">
                          <span className="text-[10px] font-semibold uppercase tracking-wider" style={lblStyle}>Prodotto</span>
                          <span className="text-[10px] font-semibold uppercase tracking-wider text-center" style={lblStyle}>Q.tà</span>
                          <span className="text-[10px] font-semibold uppercase tracking-wider text-right" style={lblStyle}>€ extra/unità</span>
                          <span></span>
                        </div>
                      )}
                      {t.kit.length === 0 && (
                        <div className="text-xs py-1" style={{ color: "var(--text-muted)" }}>Nessun prodotto nel kit.</div>
                      )}
                      {t.kit.map((k, ki) => (
                        <div key={ki} className="grid grid-cols-[1fr_90px_110px_32px] gap-2 items-center mb-1.5" data-testid={`kit-row-${ti}-${ki}`}>
                          <select value={k.prodotto_id} onChange={(e) => setKitItem(ti, ki, { prodotto_id: e.target.value })}
                            className="w-full px-2 py-1.5 text-sm rounded-md border outline-none" style={inputStyle}
                            data-testid={`kit-prodotto-${ti}-${ki}`}>
                            <option value="">— prodotto —</option>
                            {prodotti.map((p) => <option key={p.id} value={p.id}>{p.nome}{p.sku ? ` (${p.sku})` : ""}</option>)}
                          </select>
                          <input type="number" step="0.01" value={k.quantita} onChange={(e) => setKitItem(ti, ki, { quantita: num(e.target.value) })}
                            className="w-full px-2 py-1.5 text-sm rounded-md border outline-none text-center" style={inputStyle} data-testid={`kit-qty-${ti}-${ki}`} />
                          <input type="number" step="0.01" value={k.prezzo_extra} onChange={(e) => setKitItem(ti, ki, { prezzo_extra: num(e.target.value) })}
                            className="w-full px-2 py-1.5 text-sm rounded-md border outline-none text-right" style={inputStyle} data-testid={`kit-prezzo-${ti}-${ki}`} />
                          <button onClick={() => setTip(ti, { kit: t.kit.filter((_, idx) => idx !== ki) })}
                            className="p-1 rounded hover:bg-black/5 justify-self-center" data-testid={`remove-kit-${ti}-${ki}`}>
                            <Trash2 className="w-3.5 h-3.5" style={{ color: "#B30000" }} />
                          </button>
                        </div>
                      ))}
                    </div>

                    <div className="flex justify-end mt-2">
                      <button onClick={() => { setEco({ ...eco, tipologie: eco.tipologie.filter((_, idx) => idx !== ti) }); setSelTip(0); }}
                        className="text-xs font-semibold px-2 py-1 rounded hover:bg-black/5" style={{ color: "#B30000" }}
                        data-testid={`remove-tipologia-${ti}`}>
                        <Trash2 className="w-3.5 h-3.5 inline mr-1" />Rimuovi tipologia
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        <div className="p-4 border-t flex justify-end gap-2" style={{ borderColor: "var(--border)" }}>
          <button onClick={onClose} className="btn-secondary">Annulla</button>
          <button onClick={save} disabled={saving || loading} className="btn-primary" data-testid="save-economico-commessa">
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : null} Salva
          </button>
        </div>
      </div>
    </div>
  );
}
